import * as CorporateListAction from './action';
const initialState = {
    corporateList: [],
    corporateListError: [],
    transactionCheckExist: [],
    transactionCheckExistFailure: [],
    transactionDataUpload: [],
    transactionDataUploadFailure: [],
    transactionDataList: [],
    transactionDataListFailure: [],
    downloadFile: [],
    downloadFileFailure: [],
    deleteTransaction: [],
    deleteTransactionFailure: [],
    downloadTemplate: [],
    downloadTemplateFailure: [],
    downloadExcelFileSuccess:[],
    downloadExcelFileFailure:[],
    downloadNonFinancialExcelFileSuccess:[],
    downloadNonFinancialExcelFileFailure:[],
    downloadObjectListExcelFileSuccess:[],
    downloadObjectListExcelFileFailure:[],
    downloadScoreBreakupExcelFileSuccess:[],
    downloadScoreBreakupExcelFileFailure:[],
    downloadCLMBreakupExcelFileSuccess:[],
    downloadCLMBreakupExcelFileFailure:[],
    downloadCorporateCSVSuccess: false,
    downloadCorporateCSVFailure: null,

}
const CorporateListReducer = (state = initialState, action) => {
    switch (action.type) {
        case CorporateListAction.LIST_CORPORATE_SUCCESS:
            return state = {
                ...state,
                corporateList: action.data
            }
        case CorporateListAction.LIST_CORPORATE_FAILURE:
            return state = {
                ...state,
                corporateListError: action.error
            }
        case CorporateListAction.TRANSACTION_CHECK_EXIST_SUCCESS:
            return state = {
                ...state,
                transactionCheckExist: action.data
            }
        case CorporateListAction.TRANSACTION_CHECK_EXIST_FAILURE:
            return state = {
                ...state,
                transactionCheckExistFailure: action.data
            }
        case CorporateListAction.TRANSACTION_DATA_FILE_UPLOAD_SUCCESS:
            return state = {
                ...state,
                transactionDataUpload: action.data
            }
        case CorporateListAction.TRANSACTION_DATA_FILE_UPLOAD_FAILURE:
            return state = {
                ...state,
                transactionDataUploadFailure: action.data
            }
        case CorporateListAction.TRANSACTION_DATA_LIST_SUCCESS:
            return state = {
                ...state,
                transactionDataList: action.data
            }
        case CorporateListAction.TRANSACTION_DATA_LIST_FAILURE:
            return state = {
                ...state,
                transactionDataListFailure: action.data
            }
        case CorporateListAction.DOWNLOAD_TRANSACTION_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                downloadTemplate: action.data
            }
        case CorporateListAction.DOWNLOAD_TRANSACTION_TEMPLATE_FAILURE:
            return state = {
                ...state,
                downloadTemplateFailure: action.data
            }
        case CorporateListAction.DOWNLOAD_TRANSACTION_FILE_SUCCESS:
            return state = {
                ...state,
                downloadFile: action.data
            }
        case CorporateListAction.DOWNLOAD_TRANSACTION_FILE_FAILURE:
            return state = {
                ...state,
                downloadFileFailure: action.data
            }
        case CorporateListAction.DELETE_TRANSACTION_DATA_SUCCESS:
            return state = {
                ...state,
                deleteTransaction: action.data
            }
        case CorporateListAction.DELETE_TRANSACTION_DATA_FAILURE:
            return state = {
                ...state,
                deleteTransactionFailure: action.data
            }
        case CorporateListAction.DOWNLOAD_EXCEL_FILE_SUCCESS:
            return state = {
                ...state,
                downloadExcelFileSuccess: action.data
            }
        case CorporateListAction.DOWNLOAD_EXCEL_FILE_FAILURE:
            return state = {
                ...state,
                downloadExcelFileFailure: action.data
            }
        case CorporateListAction.DOWNLOAD_NON_FINANCIAL_EXCEL_FILE_SUCCESS:
                return state = {
                    ...state,
                    downloadNonFinancialExcelFileSuccess: action.data
                }
        case CorporateListAction.DOWNLOAD_NON_FINANCIAL_EXCEL_FILE_FAILURE:
                return state = {
                    ...state,
                    downloadNonFinancialExcelFileFailure: action.data
                }

                case CorporateListAction.DOWNLOAD_OBJECT_LIST_EXCEL_FILE_SUCCESS:
                    return state = {
                        ...state,
                        downloadObjectListExcelFileSuccess: action.data
                    }
            case CorporateListAction.DOWNLOAD_OBJECT_LIST_EXCEL_FILE_FAILURE:
                    return state = {
                        ...state,
                        downloadObjectListExcelFileFailure: action.data
                    }

        case CorporateListAction.DOWNLOAD_SCORE_BREAKUP_EXCEL_FILE_SUCCESS:
            return state = {
                ...state,
                downloadScoreBreakupExcelFileSuccess: action.data
            }
        case CorporateListAction.DOWNLOAD_SCORE_BREAKUP_EXCEL_FILE_FAILURE:
            return state = {
                ...state,
                downloadScoreBreakupExcelFileFailure: action.data
            }
        case CorporateListAction.DOWNLOAD_CLM_BREAKUP_EXCEL_FILE_SUCCESS:
            return state = {
                ...state,
                downloadCLMBreakupExcelFileSuccess: action.data
            }
        case CorporateListAction.DOWNLOAD_CLM_BREAKUP_EXCEL_FILE_FAILURE:
            return state = {
                ...state,
                downloadCLMBreakupExcelFileFailure: action.data
            }      
        case CorporateListAction.DOWNLOAD_CORPORATE_CSV_SUCCESS:
            return {
                ...state,
                downloadCorporateCSVSuccess: true,
                downloadCorporateCSVFailure: null
            };

        case CorporateListAction.DOWNLOAD_CORPORATE_CSV_FAILURE:
            return {
                ...state,
                downloadCorporateCSVSuccess: false,
                downloadCorporateCSVFailure: action.error
            };

      
        default: return state
    }
};

export default CorporateListReducer; 